module.exports = __webpack_public_path__ + "static/images/ercode_2.7e9cf78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ercode_2.png
// module id = rUdi
// module chunks = 8